import React, { useEffect } from 'react';
import { Col, Row } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../store/configureStore';
import { NavLink } from 'react-router-dom';
import { Path } from '../App';
import { helperActionCreators } from '../store/HelperStore';
import Skeleton from "react-loading-skeleton";
import { stateLoading } from '../functions/stateLoading';

type TPageNotFoundProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;


const PageNotFound = (props: TPageNotFoundProps) => {

    useEffect(() => {
        if (stateLoading(props.helper)) {
            props.fetchAllConfiguration();
        }
    });  

    return (
        <Row className="justify-content-center">
            <Col className="col-12 col-md-6 col-lg-5 col-xl-5">
                <Row className="errorCard">
                    <Col className="errorCardTitle">
                        Sorry!
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            We apologize but it seems we could not find the page you are looking for.
                        </p>

                        <Row className="mt-4">
                            <Col className="col-12">
                                {props.dcr.authenticated ?
                                    <NavLink to={Path.ContributionHistory} className="text-nowrap">Manage Contribution</NavLink>
                                    : (props.helper.xspURLReponseInfo?.url
                                            ? <NavLink to={props.helper.xspURLReponseInfo?.url}>Login</NavLink>
                                            : <LoadingSkeleton />)
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}


const LoadingSkeleton = () => (
    <Row className="logout-container">
        <Col>
            <div className="row container">
                <div className="col-12 pl-2">
                    <div className="mt-2"><Skeleton width={'105%'} /></div>
                    <div><Skeleton width={'105%'} /></div>
                </div>
            </div>
        </Col>
    </Row>
);

function mapStateToProps(state: AppState) {
    return {
        dcr: state.dcr,
        helper: state.helper
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            ...helperActionCreators
        }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PageNotFound);  